import { validationMessages } from '../../utils/validationMessages';

const DirectDebitFormModel = {
  formField: {
    FirstName: {
      name: 'FirstName',
      label: 'First name*',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Surname: {
      name: 'Surname',
      label: 'Surname*',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    FullName: {
      information_text: 'Please ensure your first name and surname fields above match your bank account name.'
    },
    BIC: {
      name: 'BIC',
      label: 'BIC',
      maxStringCount: 11,
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      },
      get incorrectBicErrorMsg(): string {
        return validationMessages.invalid(this.label);
      }
    },
    IBAN: {
      name: 'IBAN',
      label: 'IBAN*',
      maxStringCount: 34,
      get maxStringCountErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get incorrectIbanErrorMsg(): string {
        return validationMessages.invalid(this.label);
      }
    },
    TypeOfDirectDebit: {
      name: 'TypeOfDirectDebit',
      label: 'Type of direct debit*',
      information_text: 'If you wish to do a once off payment please hit cancel and select card payments.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    PaymentFrequency: {
      name: 'PaymentFrequency',
      label: 'Payment frequency*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Declaration: {
      name: 'Declaration',
      label: `By checking this box , you authorize (A) RCSI to send instructions to your bank to debit your account 
      and (B) Your bank to debit your account in accordance with the instructions from RCSI.*`,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    UniqueMandateReference: {
      name: 'UniqueMandateReference',
      label: 'Unique Mandate Reference'
    },
    Product: {
      name: 'Product',
      label: 'Product'
    },
    Amount: {
      name: 'Amount',
      label: 'Amount'
    },
    Frequency: {
      name: 'Frequency',
      label: 'Frequency'
    },
    Creditor: {
      name: 'Creditor',
      label: 'Creditor'
    }
  }
};

export default DirectDebitFormModel;
